import React from "react";
import CreateProjectWizard from "../components/createProject/CreateProjectWizard";

const CreateProjectPage: React.FC = () => {
  return <CreateProjectWizard />;
};

export default CreateProjectPage;
